import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "../layout";
import { useTranslation } from "react-i18next";

const TourGuideBrochure = () => {
    const { t } = useTranslation();
    const me = useSelector(state => state.API.me);

    return (
        <Layout selected="tourguide">
            <div className="brochure-page" style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1rem' }}>
                <nav aria-label="breadcrumb" className="breadcrumb-nav">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
	                            <Link to="/">{t('home')}</Link>
	                        </li>
	                        <li className="breadcrumb-item active">{t('become-tourguide')}</li>
                    </ol>
                </nav>

                <div className="text-center mb-5">
	                    <h1 style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>{t('brochure-share-world')}</h1>
	                    <p className="lead text-muted" style={{ maxWidth: '600px', margin: '0 auto' }}>
	                        {t('brochure-subtitle')}
	                    </p>
                </div>

                <div className="row mb-5">
                    <div className="col-md-4 text-center mb-4">
                        <div className="feature-icon mb-3">
                            <i className="bi bi-calendar-check" style={{ fontSize: '2.5rem', color: '#e17055' }}></i>
                        </div>
	                        <h4>{t('brochure-publish-anytime')}</h4>
	                        <p className="text-muted">{t('brochure-publish-anytime-text')}</p>
                    </div>
                    <div className="col-md-4 text-center mb-4">
                        <div className="feature-icon mb-3">
                            <i className="bi bi-cash-stack" style={{ fontSize: '2.5rem', color: '#e17055' }}></i>
                        </div>
	                        <h4>{t('brochure-earn-money')}</h4>
	                        <p className="text-muted">{t('brochure-earn-money-text')}</p>
                    </div>
                    <div className="col-md-4 text-center mb-4">
                        <div className="feature-icon mb-3">
                            <i className="bi bi-people" style={{ fontSize: '2.5rem', color: '#e17055' }}></i>
                        </div>
	                        <h4>{t('brochure-meet-people')}</h4>
	                        <p className="text-muted">{t('brochure-meet-people-text')}</p>
                    </div>
                </div>

                <div className="bg-light rounded p-4 mb-5">
	                    <h2 className="mb-4">{t('brochure-how-it-works')}</h2>
                    
                    <div className="d-flex mb-4">
                        <div className="step-number me-3" style={{ 
                            width: '40px', 
                            height: '40px', 
                            borderRadius: '50%', 
                            background: '#e17055', 
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            flexShrink: 0
                        }}>1</div>
                        <div>
	                            <h5 className="mb-1">{t('brochure-step-profile')}</h5>
	                            <p className="text-muted mb-0">{t('brochure-step-profile-text')}</p>
                        </div>
                    </div>

                    <div className="d-flex mb-4">
                        <div className="step-number me-3" style={{ 
                            width: '40px', 
                            height: '40px', 
                            borderRadius: '50%', 
                            background: '#e17055', 
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            flexShrink: 0
                        }}>2</div>
                        <div>
	                            <h5 className="mb-1">{t('brochure-step-tours')}</h5>
	                            <p className="text-muted mb-0">{t('brochure-step-tours-text')}</p>
                        </div>
                    </div>

                    <div className="d-flex mb-4">
                        <div className="step-number me-3" style={{ 
                            width: '40px', 
                            height: '40px', 
                            borderRadius: '50%', 
                            background: '#e17055', 
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            flexShrink: 0
                        }}>3</div>
                        <div>
	                            <h5 className="mb-1">{t('brochure-step-grow')}</h5>
	                            <p className="text-muted mb-0">{t('brochure-step-grow-text')}</p>
                        </div>
                    </div>
                </div>

                <div className="text-center py-4">
	                    <h3 className="mb-4">{t('brochure-ready')}</h3>
                    {me ? (
                        <div className="d-flex flex-column gap-3 align-items-center">
                            <Link to="/tourguide/edit" className="btn-primary">
	                                <i className="bi bi-person-plus me-2"></i>{t('guide-create-profile')}
	                            </Link>
	                            <span className="text-muted">{t('brochure-or')}</span>
	                            <Link to="/tourguide" className="btn-outline">
	                                {t('brochure-go-dashboard')}
	                            </Link>
                        </div>
                    ) : (
                        <div className="d-flex flex-column gap-3 align-items-center">
	                            <p className="text-muted">{t('brochure-create-account')}</p>
	                            <Link to="/signup" className="btn-primary">
	                                {t('brochure-sign-up-now')}
	                                <i className="bi bi-arrow-right ms-2"></i>
                            </Link>
                        </div>
                    )}
                </div>

                <hr className="my-5" />

                <div className="mb-4">
	                    <h3 className="mb-3">{t('brochure-promise')}</h3>
                    <div className="row">
                        <div className="col-md-6 mb-3">
                            <div className="d-flex align-items-start">
                                <i className="bi bi-check-circle-fill text-success me-2" style={{ marginTop: '3px' }}></i>
                                <div>
	                                    <strong>{t('brochure-no-hidden-fees')}</strong>
	                                    <p className="text-muted small mb-0">{t('brochure-no-hidden-fees-text')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="d-flex align-items-start">
                                <i className="bi bi-check-circle-fill text-success me-2" style={{ marginTop: '3px' }}></i>
                                <div>
	                                    <strong>{t('brochure-control')}</strong>
	                                    <p className="text-muted small mb-0">{t('brochure-control-text')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="d-flex align-items-start">
                                <i className="bi bi-check-circle-fill text-success me-2" style={{ marginTop: '3px' }}></i>
                                <div>
	                                    <strong>{t('brochure-easy-tools')}</strong>
	                            <p className="text-muted small mb-0">{t('brochure-easy-tools-text')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 mb-3">
                            <div className="d-flex align-items-start">
                                <i className="bi bi-check-circle-fill text-success me-2" style={{ marginTop: '3px' }}></i>
                                <div>
	                                    <strong>{t('brochure-global-reach')}</strong>
	                                    <p className="text-muted small mb-0">{t('brochure-global-reach-text')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default TourGuideBrochure;
